import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { UploadAssetComponent } from '../../components/upload-asset/upload-asset.component';

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuardService implements CanDeactivate<UploadAssetComponent>{

  constructor() { }

  canDeactivate(component : UploadAssetComponent){
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
